export const locale = {
  lang: 'en',
  data: {
    MENU: {
      LOG: 'Log',
      COMPANY: 'Empresaas',
      USERS: 'Usuarios'
    }
  }
}
